const coatingData=[
 {name:'PIXAR UV',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarUv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection']},

 {name:'PIXAR BLUV',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarBluv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection','Blue Light protection']},

 {name:'PIXAR AQUA',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAqua.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},

 {name:'PIXAR DRIVE',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarDrive.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},

 {name:'PIXAR ANTIFOG',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAntifog.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Blue Light protection']}
];

function renderCoating(i=0){
  const tabs=document.getElementById('coatingTabs'),
        box=document.getElementById('coatingBox');

  if(!tabs || !box) return;

  tabs.innerHTML=coatingData.map((c,n)=>`
    <button class="gt-coating-tab ${n===i?'active':''}" onclick="renderCoating(${n})">
      <img src="${c.img}" alt="${c.name}">
    </button>
  `).join('');

  const iconMap = {
    'Prevents reflections, presents pure vision':'✳',
    'Superhydrophobic, water repellent':'💧',
    'Anti-scratch':'✺',
    'Anti-dust, easy clean':'◎',
    'Anti-fog':'☕',
    'Max UV Protection':'☂',
    'Blue Light protection':'⌁'
  };

  box.innerHTML=coatingData[i].features.map(f=>`
    <div class="gt-feature">
      <div class="gt-icon">${iconMap[f] || '✳'}</div>
      <span>${f}</span>
    </div>
  `).join('');
}

const lensData={
 "1.50":[
  {name:"Clear",type:"Individual freeform progressive",index:"1.50",abbe:58,density:"1.32",uv:350,rx:[[-3,5],[-6,8],[-8,8],[-9,12],[-10,12]],colors:""},
  {name:"Transitions",type:"Photochromic, Individual freeform progressive",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[0,0],[0,0],[-10,7],[-11,7],[-12,7]],colors:"Brown,Smoked"},
  {name:"Transitions XTRActive",type:"Photochromic, Individual freeform progressive",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[0,0],[-6,7],[-10,7],[-11,7],[-12,7]],colors:"Smoked"},
  {name:"NuPolar",type:"Polarized, Individual freeform progressive",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[-3,5],[-6,7],[-7,7],[-8,7],[-9,7]],colors:"Brown,Smoked,G15"},
  {name:"DriveWear",type:"Photochromic, Individual freeform progressive",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[0,0],[0,0],[-8,7],[-9,7],[-10,7]],colors:""}
 ],
 "1.53":[
  {name:"Trivex",type:"Individual freeform progressive",index:"1.53",abbe:45,density:"1.11",uv:385,rx:[[0,0],[-5,6],[-8,8],[-9,8],[-10,8]],colors:"",thin:"%35 thinner"},
  {name:"Trivex Transitions",type:"Photochromic Individual freeform progressive",index:"1.53",abbe:45,density:"1.11",uv:400,rx:[[0,0],[-6,6],[-8,8],[-9,8],[-10,8]],colors:"Smoked"}
 ],
 "1.57":[
  {name:"Q-vex",type:"Individual freeform progressive",index:"1.57",abbe:46,density:"1.15",uv:400,rx:[[-3,5],[-4,7],[-10,7],[-11,10],[-10,12]],colors:"",thin:"%40 thinner"},
  {name:"Q-vex Wizard",type:"Photochromic Individual freeform progressive",index:"1.57",abbe:46,density:"1.15",uv:400,rx:[[0,0],[-3,6],[-11,6],[-12,6],[-13,6]],colors:""}
 ],
 "1.58":[
  {name:"Clear",type:"Individual freeform progressive",index:"1.58",abbe:38,density:"1.28",uv:380,rx:[[-3,5],[-4,7],[-10,7],[-11,13],[-12,13]],colors:"",thin:"%40 thinner"},
  {name:"Wizard",type:"Photochromic, Individual freeform progressive",index:"1.58",abbe:58,density:"1.32",uv:380,rx:[[0,0],[-10,6],[-11,6],[-12,6],[-13,6]],colors:""}
 ],
 "1.59 PC":[
  {name:"PC",type:"Polycarbonate, Individual freeform progressive",index:"1.59",abbe:30,density:"1.22",uv:380,rx:[[0,0],[0,0],[-10,7],[-11,7],[-12,8]],colors:"",thin:"%40 thinner"},
  {name:"PC Transitions",type:"Photochromic Polycarbonate, Individual freeform progressive",index:"1.59",abbe:30,density:"1.22",uv:400,rx:[[0,0],[-6,5],[-8,8],[-9,8],[-10,8]],colors:"Smoked"},
  {name:"PC NuPolar",type:"Polarized Polycarbonate, Individual freeform progressive",index:"1.59",abbe:30,density:"1.22",uv:400,rx:[[0,0],[-7,6],[-8,6],[-9,6],[-10,6]],colors:"Brown,Smoked"}
 ],
 "1.61":[
  {name:"Clear",type:"Individual freeform progressive",index:"1.61",abbe:42,density:"1.30",uv:385,rx:[[0,0],[-7,8],[-10,11],[-12,11],[-12,11]],colors:"",thin:"%45 thinner"},
  {name:"Wizard",type:"Individual freeform progressive",index:"1.61",abbe:42,density:"1.30",uv:400,rx:[[0,0],[-9,6],[-10,6],[-11,6],[-12,6]],colors:"Brown,Smoked"},
  {name:"Transitions",type:"Photochromic, Individual freeform progressive",index:"1.61",abbe:42,density:"1.30",uv:400,rx:[[0,0],[-0,0],[-10,9],[-11,9],[-12,9]],colors:"Brown,Smoked"}
 ],
 "1.67":[
  {name:"Clear",type:"Individual freeform progressive",index:"1.67",abbe:34,density:"1.37",uv:390,rx:[[0,0],[-9,7],[-10,11],[-11,11],[-12,11]],colors:"",thin:"%60 thinner"},
  {name:"Wizard",type:"Individual freeform progressive",index:"1.67",abbe:34,density:"1.37",uv:400,rx:[[0,0],[-9,6],[-10,6],[-11,6],[-12,6]],colors:"Brown,Smoked"},
  {name:"Transitions",type:"Photochromic, Individual freeform progressive",index:"1.67",abbe:34,density:"1.37",uv:400,rx:[[0,0],[0,0],[-8,10],[-9,10],[-10,10]],colors:"Brown,Smoked"},
  {name:"NuPolar",type:"Polarized, Individual freeform progressive",index:"1.67",abbe:34,density:"1.37",uv:400,rx:[[0,0],[-10,7],[-11,7],[-12,7],[-13,7]],colors:"Brown,Smoked"}
 ],
 "1.74":[
  {name:"Clear",type:"Individual freeform progressive",index:"1.74",abbe:33,density:"1.47",uv:395,rx:[[0,0],[0,0],[-15,12],[-16,12],[-17,12]],colors:"",thin:"%65 thinner"},
  {name:"Transitions",type:"Photochromic, Individual freeform progressive",index:"1.74",abbe:33,density:"1.47",uv:400,rx:[[0,0],[0,0],[-13,11],[-14,11],[-15,11]],colors:"Smoked"}
 ]
};

let currentIndex="1.50";
let currentMaterial=0;

function renderTabs(){
 const indexTabs=document.getElementById('indexTabs');
 const materialTabs=document.getElementById('materialTabs');
 indexTabs.innerHTML=Object.keys(lensData).map(k=>`<button class="gt-index-tab ${k===currentIndex?'active':''}" onclick="selectIndex('${k}')">${k}</button>`).join('');
 materialTabs.innerHTML=lensData[currentIndex].map((m,i)=>`<button class="gt-material-tab ${i===currentMaterial?'active':''}" onclick="selectMaterial(${i})">${m.name}</button>`).join('');
}

function selectIndex(i){currentIndex=i;currentMaterial=0;renderAll()}
function selectMaterial(i){currentMaterial=i;renderAll()}

function rxRows(rx){
 const dia=[80,75,70,65,60];
 const vals=rx.flat().filter(v=>v!==0);
 const minRx=Math.min(-18,...vals)-1;
 const maxRx=Math.max(14,...vals)+2;
 const range=maxRx-minRx;

 return rx.map((r,i)=>{
  if(r[0]===0&&r[1]===0){
   return `<div class="gt-rx-row"><div class="gt-rx-dia">${dia[i]}</div><div class="gt-rx-track"></div></div>`;
  }

  const left=((r[0]-minRx)/range)*100;
  const width=((r[1]-r[0])/range)*100;

  return `<div class="gt-rx-row">
    <div class="gt-rx-dia">${dia[i]}</div>
    <div class="gt-rx-track">
      <div class="gt-rx-fill" style="left:${left}%;width:${width}%">
        <span class="gt-rx-left">${r[0]}</span>
        <span class="gt-rx-right">+${r[1]}</span>
      </div>
    </div>
  </div>`;
 }).join('');
}

function renderDetails(){
 const d=lensData[currentIndex][currentMaterial];

 document.getElementById('lensType').textContent=d.type;
 document.getElementById('metricIndex').textContent=d.index;
 document.getElementById('metricAbbe').textContent=d.abbe;
 document.getElementById('metricDensity').textContent=d.density;
 document.getElementById('metricUv').innerHTML=d.uv+'<br>nm';
 document.getElementById('densityFill').style.height=Math.min(100,parseFloat(d.density)/1.5*100)+'%';
 document.getElementById('rxChart').innerHTML=rxRows(d.rx);

 let note='FreeForm bifocal technology supports personalized lens production with clear distance and near zones. The design helps reduce unwanted distortion and supports comfortable everyday visual performance.';
 if(d.name.toLowerCase().includes('polar')) note+=' Polarized design helps reduce glare from reflected light and improves contrast.';
 if(d.name.toLowerCase().includes('transition')||d.name.toLowerCase().includes('wizard')) note+=' Photochromic technology helps protect the eyes from harmful UV radiation.';
 if(d.index==="1.53"||d.name.includes("Q-vex")) note+=' Trivex/Q-vex material provides high resistance to breakage and is suitable for rimless and sport eyewear.';
 if(d.index==="1.59") note+=' Polycarbonate material provides impact resistance and added safety for rimless and sport frames.';

 document.getElementById('lensNote').textContent=note;
 document.getElementById('thinNote').innerHTML=d.thin?`${d.thin}<small>(compared to 1.5 index organic lenses)</small>`:'';

 const colors=document.getElementById('colorOptions');
 if(!d.colors){colors.innerHTML='';return}

 colors.innerHTML='Color Options : '+d.colors.split(',').map(c=>{
  const cls=c.trim()==='Brown'?'brown':c.trim()==='G15'?'g15':'';
  return `${c.trim()} <span class="gt-dot ${cls}"></span>`;
 }).join(' ');
}

function renderAll(){renderTabs();renderDetails()}

document.addEventListener('DOMContentLoaded',function(){
 renderCoating();
 renderAll();
});